import { AriaAttributes, createContext, Ref, useContext, useMemo } from 'react'

export type SelectContext = {
  open: boolean
  invalid?: boolean
  disabled?: boolean
  buttonRef?: Ref<HTMLButtonElement>
  ariaInvalid?: AriaAttributes['aria-invalid']
  ariaDescribedBy?: string
  ariaLabelledBy?: string
}

const SelectContext = createContext<SelectContext>(undefined)

export const SelectProvider = ({
  open,
  invalid,
  disabled,
  buttonRef,
  ariaInvalid,
  ariaDescribedBy,
  ariaLabelledBy,
  children,
}) => {
  const value = useMemo(
    () => ({
      open,
      invalid,
      disabled,
      buttonRef,
      ariaInvalid,
      ariaDescribedBy,
      ariaLabelledBy,
    }),
    [
      open,
      invalid,
      disabled,
      buttonRef,
      ariaInvalid,
      ariaDescribedBy,
      ariaLabelledBy,
    ],
  )

  return (
    <SelectContext.Provider value={value}>{children}</SelectContext.Provider>
  )
}

export const useSelect = () => {
  const context = useContext(SelectContext)
  if (context === undefined) {
    throw new Error('useSelect must be used within a SelectProvider')
  }
  return context
}
